window.Products.WallArt.AcrylicPrint = function() {};
window.Products.WallArt.AcrylicPrint.inherits(window.Products.WallArt.ArtProduct);
window.Products.WallArt.AcrylicPrint.id = 76;
window.Products.WallArt.AcrylicPrint.saveId = 37;
window.Products.WallArt.AcrylicPrint.slug = 'acrylic-print';
window.Products.WallArt.AcrylicPrint.has_3d = true;
window.Products.WallArt.AcrylicPrint.use_variants = true;
window.Products.WallArt.AcrylicPrint.dpi = 300;

window.Products.WallArt.AcrylicPrint.prototype.set3dProperties = function(modelViewer) {
	var me = this;
	me.updateThreeTexture(modelViewer);
	me.loadEnvMap(function(){
		modelViewer.object.children[0].material[1].envMap = me.envMap;
		modelViewer.object.children[0].material[1].envMap.mapping = THREE.EquirectangularReflectionMapping;
		modelViewer.object.children[0].material[1].reflectivity = 0.5;
		modelViewer.object.children[0].material[1].needsUpdate = true;
		modelViewer.object.children[0].material[1].envMap.needsUpdate = true;
	});
	modelViewer.ambient_light.intensity = 0.6;
	modelViewer.camera.position.z = 1.78;
	modelViewer.initalCameraPosition.z = 1.78;
};

window.Products.WallArt.AcrylicPrint.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[0].material[4].map = modelViewer.texture;
};

window.Products.WallArt.AcrylicPrint.prototype.setThreeControls = function(controls) {
	controls.minDistance = 2.4;
	controls.maxDistance = 2.4;
	controls.minPolarAngle = Math.PI/2;
	controls.maxPolarAngle = Math.PI/2;
};